<template>
  <div>
      <CardWithImageAndButton
      title="Сканер уязвимостей"
      text="Современный сканер уязвимостей, спроектированный для организаций, которым важно не просто выявлять угрозы, а оперативно на них реагировать.
      <br /><br />
      Система ежедневно обрабатывает тысячи IP-адресов, выявляя уязвимости в ИТ-ландшафте компаний, включая критически важные объекты и распределённые инфраструктуры.
      <br /><br />
      В основе продукта — масштабируемая архитектура, которая легко адаптируется под любые объёмы задач.
      <br /><br />
      Используемые технологии: Go, JavaScript, Postgres, Redis.
      "
      :imagePath="require('../../assets/imgs/scanner.png')"
      imagePosition="right"
      :buttonIsVisible="false"
      />
      <List :items="listItems" title="Задачи" theme="dark" />
      <List title="Реализация" :items=secondListItems />
      <MultiColumnListWithIcons
      header="Мощные инструменты для мониторинга сети"
      text="Обеспечьте контроль и безопасность вашей инфраструктуры"
      :items="multiColumnListItems"
      theme="dark"
      />
  </div>
</template>

<script>
import { CardWithImageAndButton, List, MultiColumnListWithIcons } from 'sputnik-ui/src/index';
export default {
  name: 'ScannerPage',
  components: {
    CardWithImageAndButton,
    List,
    MultiColumnListWithIcons
  },
  data() {
    return {
      listItems: [
        { text: 'Поиск уязвимостей на объектах КИИ рунета'},
        { text: 'Автоматизированный контроль защищенности'},
        { text: 'Обнаружение утечек данных'},
        { text: 'Агрегация данных из Shodan и других источников'},
        { text: 'Разграничение доступа территориальных структур'},
        { text: 'Выявление и оценка IoT устройств'},
      ],
      secondListItems: [
        {text: "Создана объединенная база знаний уязвимостей"},
        {text: "Масштабируемая система мониторинга"},
        {text: "Отслеживание уязвимостей в реальном времени"},
        {text: "Обнаружение утечек информации"},
        {text: "Анализ уязвимостей устройств IoT"},
      ],
      multiColumnListItems: [
        {
          icon: require('@/assets/icons/star.svg'),
          header: '> 200 000',
          text: 'ресурсов для контроля'
        },
        {
          icon: require('@/assets/icons/star.svg'),
          header: '> 2 000',
          text: 'IP-адресов в сутки сканирует один узел кластера'
        },
      ]
    };
  },
};
</script>
